import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
import "./index.css";
import "./i18n";

import { GoogleOAuthProvider } from "@react-oauth/google";

const portalDiv = document.getElementById("root")!;
const root = ReactDOM.createRoot(portalDiv);
root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider
      clientId={String(process.env.REACT_APP_GOOGLE_CLIENT_ID)}
    >
      <App />
    </GoogleOAuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
